module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-7-1ff0574e4941c492587171d13b4152bd.svg";